export const Type = {
  ADD_TO_BASKET: "ADD_TO_BASKET",
  REMOVE_FROM_BASKET: "REMOVE_FROM_BASKET",
  USER: "USER",
  USER_INFO: "USER_INFO",
  EMPTY_BASKET: "EMPTY_BASKET",
  SET_AMOUNT: "SET_AMOUNT",
};
